import React, { Component, createRef } from "react";
import { addDays, differenceInCalendarDays, format, isBefore } from "date-fns";

import { getAirlines } from "../../../../lib/getAirlines";
import cf from "../../../../lib/utils/common";
import commonFunction from "../../../../lib/utils/common";
import ModifyAdvanceSearchMulticity from "../../../b2bwidgets/theme4/ModifyAdvanceSearchMulticity";
import ModifyAdvanceSearchOneWay from "../../../b2bwidgets/theme4/ModifyAdvanceSearchOneWay";
import ModifyAdvanceSearchRoundTrip from "../../../b2bwidgets/theme4/ModifyAdvanceSearchRoundtrip";
import DesktopCalender from "../../../calendar/flightCalender/theme4/modifySearch/DesktopCalender";
import MultiSuppilerDropDownoption from "../../../multiDropdown/theme4/index";
import MultiSelectDropDown from "../../../multiSelect/multiSelectDropDown";
import EconomyPopup from "./EconomyPopup";
import FlightAutoComplete from "./FlightAutoComplete";
import ModifySearchForm from "./ModifySearchForm";
import { getUrl, parseurl } from "../../../../lib/flight/urlParser";

const cabinClass = [
  { id: 1, value: "Economy", label: "Economy" },
  { id: 2, value: "Business", label: "Business" },
  { id: 3, value: "First Class", label: "First Class" },
  { id: 4, value: "Premium Economy", label: "Premium Economy" },
];

const rbdClass = [
  { label: "All", value: "*", isChecked: false },
  { label: "A", value: "A", isChecked: false },
  { label: "B", value: "B", isChecked: false },
  { label: "C", value: "C", isChecked: false },
  { label: "D", value: "D", isChecked: false },
  { label: "E", value: "E", isChecked: false },
  { label: "F", value: "F", isChecked: false },
  { label: "G", value: "G", isChecked: false },
  { label: "H", value: "H", isChecked: false },
  { label: "I", value: "I", isChecked: false },
  { label: "J", value: "J", isChecked: false },
  { label: "K", value: "K", isChecked: false },
  { label: "L", value: "L", isChecked: false },
  { label: "M", value: "M", isChecked: false },
  { label: "N", value: "N", isChecked: false },
  { label: "O", value: "O", isChecked: false },
  { label: "P", value: "P", isChecked: false },
  { label: "Q", value: "Q", isChecked: false },
  { label: "R", value: "R", isChecked: false },
  { label: "S", value: "S", isChecked: false },
  { label: "T", value: "T", isChecked: false },
  { label: "U", value: "U", isChecked: false },
  { label: "V", value: "V", isChecked: false },
  { label: "W", value: "W", isChecked: false },
  { label: "X", value: "X", isChecked: false },
  { label: "Y", value: "Y", isChecked: false },
  { label: "Z", value: "Z", isChecked: false },
];

const todaysDate = format(new Date(), "dd-LLL-yyyy");
let search_type = "";
let airline = [];

// const DepartureTime = [
//   { label: "All", value:"All" , isChecked: true},
//   { label: "Before 6 AM", value: "Before 6 AM", isChecked: false },
//   { label: "6 AM - 12 PM", value: "6 AM - 12 PM", isChecked: false },
//   { label: "12 PM - 6 PM", value: "12 PM - 6 PM", isChecked: false },
//   { label: "After 6 PM", value: "After 6 PM", isChecked: false }
// ]

const DepartureTime = [
  { label: "All", value: "", isChecked: true, code: "" },
  { label: "Before 6 AM", value: "00000559", isChecked: false },
  { label: "6 AM - 12 PM", value: "06001159", isChecked: false },
  { label: "12 PM - 6 PM", value: "12001759", isChecked: false },
  { label: "After 6 PM", value: "18002359", isChecked: false },
];

class ModifySearch extends Component {
  constructor(props) {
    super(props);
    this.setState = this.setState.bind(this);
    this.travellerDivRef = createRef();
    this.economyPopUpWrapper = createRef();
    this.cabinPopUpWrapperTwo = createRef();
    this.departureListWrapper = createRef();
    this.returnListWrapper = createRef();
    this.multicityDepartureWrapper = createRef();
    this.passengerDropdownWrapper = createRef();
    this.multicityReturnWrapper = createRef();
    this.box = createRef(null);
    console.log("queryParams===>", props);
    let urseurl = parseurl(props.queryParams.sector);
    let returnDate = format(
      addDays(new Date(urseurl[0]?.date), 7),
      "dd-LLL-yyyy"
    );
    if (urseurl?.[1]?.date && props.queryParams.type == "2") {
      let dayDifference = differenceInCalendarDays(
        new Date(urseurl[1]?.date),
        new Date(urseurl[0]?.date)
      );
      if (dayDifference >= 0) {
        //     returnDate = format(addDays(new Date(props?.queryParams?.departure), 7), 'dd-LLL-yyyy')
        // } else {
        returnDate = format(new Date(urseurl[1]?.date), "dd-LLL-yyyy");
      }
    }
    let pax = props.queryParams.pax.split("_");
    let multicity = urseurl.map((flightObj) => {
      console.log("flgtightObj", flightObj);
      return {
        org: flightObj.from,
        dest: flightObj.to,
        odt: flightObj.date,
        advancesearch:
          props.queryParams.isAdvanceSearch == "true"
            ? {
                airlines: flightObj.airlines || [],
                fcs: flightObj.rbd || [],
                dtym:
                  flightObj.departuretime == "" || !flightObj.departuretime
                    ? ""
                    : flightObj.departuretime,
                cabinclass: flightObj.cabin || "",
                bagreq: true,
              }
            : { airlines: [], fcs: [], dtym: "", cabinclass: "", bagreq: true },
      };
    });
    this.state = {
      departureDate: urseurl[0]?.date
        ? format(new Date(urseurl[0]?.date), "dd-LLL-yyyy")
        : format(new Date(), "dd-LLL-yyyy"),
      returnDate: returnDate,
      guest: props?.queryParams?.guests,
      expandDepartureDateBoolean: false,
      expandReturnDateBoolean: false,
      isOnewaySearch: props?.queryParams?.type === "1" ? true : false,
      departureValue: urseurl[0]?.from
        ? `${urseurl[0]?.from} - (${urseurl[0]?.from})`
        : "",
      goingToValue: urseurl[0]?.to
        ? `${urseurl[0]?.to} - (${urseurl[0]?.to})`
        : "",
      expandDepartureBoolean: false,
      expandGoingToBoolean: false,
      paxAdultValue: +pax[0],
      paxChildrenValue: +pax[1],
      paxInfantValue: +pax[2],
      SelectedClassValue: cabinClass.find((cls) => cls.id == urseurl[0]?.cabin),
      openCabinClassList: false,
      getDepartureSuggestionList: this.props.homeData,
      getGoingToSuggestionList: this.props.homeData,
      departureAirportCode: urseurl[0]?.from,
      goingToAirportCode: urseurl[0]?.to,
      isError: {
        departure: false,
        goingTo: false,
        departureDate: false,
        goingToDate: false,
      },
      returnCity: urseurl[0]?.to || "",
      departureCity: urseurl[0]?.from || "",
      isTravelersPopupVisible: false,
      travellersObjOrigin: {
        adults: +pax[0],
        child: +pax[1],
        infants: +pax[2],
        originalSelectedClass:
          cabinClass && cabinClass?.find((cls) => cls.id == urseurl[0]?.cabin),
      },
      code: "",
      name: "",
      isMultiCitySearch: false,
      isValid: false,
      openCabinClassListOne: false,
      openCabinClassListTwo: false,
      selectedGoingToIndex: null,
      selectedDepartureIndex: null,
      selectedClassIndex: null,
      indexDropdown: -1,
      multicityFlightData:
        props?.queryParams?.type === "3"
          ? multicity
          : [
              {
                org: "",
                dest: "",
                odt: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
                disabledDate: cf.getDateWithFormat(
                  new Date(),
                  this?.props?.dateFormat
                ),
                advancesearch: {
                  airlines: [],
                  fcs: rbdClass,
                  dtym: DepartureTime,
                  cabinclass: { label: "Economy", id: 1 },
                },
              },
              {
                org: "",
                dest: "",
                odt: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
                disabledDate: cf.getDateWithFormat(
                  new Date(),
                  this?.props?.dateFormat
                ),
                advancesearch: {
                  airlines: [],
                  fcs: rbdClass,
                  dtym: DepartureTime,
                  cabinclass: { label: "Economy", id: 1 },
                },
              },
            ],
      openAirlines:
        props?.queryParams?.isAdvanceSearch === "true" ? true : false,
      openPaxList: false,
      SelectedAdvanceSearchOneWayClassValue: cabinClass.find(
        (cls) => cls.id == urseurl[0]?.cabin
      ),
      SelectedAdvanceSearcheRoundClassValueOne: { label: "Economy", id: 1 },
      SelectedAdvanceSearchRoundClassValueTwo: { label: "Economy", id: 1 },
      selectedAirlines: urseurl[0]?.airlines,
      selectedSupplier: urseurl[0]?.supplier,
      selectedDepartureTime: urseurl[0]?.departuretime,
      selectedRbdClass: urseurl[0]?.rbd,
      dateLimit: cf.getDateWithFormat(new Date(), this?.props?.dateFormat),
    };
  }

  componentDidMount() {
    let urseurl = parseurl(this.props.queryParams.sector);

    const { queryParams, selectedAirlines, selectedRbdClass, DepartTime } =
      this.props;
    const { multicityFlightData } = this.state;

    if (queryParams?.type === "3") {
      this.setState({ isMultiCitySearch: true });
    }

    if (queryParams?.type === "2") {
      if (queryParams.isAdvanceSearch === "true") {
        this.setState({
          SelectedAdvanceSearcheRoundClassValueOne: cabinClass.find(
            (ele) => ele.id == urseurl[0]?.cabin
          ),
          SelectedAdvanceSearchRoundClassValueTwo: cabinClass.find(
            (ele) => ele.id == urseurl[1]?.cabin
          ),
        });
      }
    }

    const updateAirlines = (item) => {
      const tempOptions = item.advancesearch.airlines || [];
      const updatedAirlines = selectedAirlines.map((airline) => ({
        ...airline,
        isChecked: tempOptions.includes(airline.value),
      }));
      item.advancesearch.airlines = updatedAirlines;
    };

    const updateRbdClass = (item) => {
      const tempOptions = item.advancesearch.fcs || [];
      const updatedRbdClass = selectedRbdClass.map((rbdClass) => ({
        ...rbdClass,
        isChecked: tempOptions.includes(rbdClass.value),
      }));
      item.advancesearch.fcs = updatedRbdClass;
    };

    const updateDepartTime = (item) => {
      const tempOption = item.advancesearch.dtym;
      const updatedDepartTime = DepartTime.map((element) => ({
        ...element,
        isChecked: element.value === tempOption,
      }));
      item.advancesearch.dtym = updatedDepartTime;
    };

    if (queryParams.isAdvanceSearch === "true") {
      multicityFlightData.forEach((item) => {
        item.disabledDate = item.odt;
        updateAirlines(item);
        item.advancesearch.cabinclass = cabinClass.find(
          (cls) => cls.id === item.advancesearch.cabinclass
        );
        updateRbdClass(item);
        updateDepartTime(item);
      });
    }

    document.addEventListener("mousedown", this.handleClickOutside, false);
    document.addEventListener("keydown", this.handleTabInside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside, false);
    document.removeEventListener("keydown", this.handleTabInside);
  }

  handleClickOutside = (event) => {
    // console.log("asdfg",this.economyPopUpWrapper.current && !this.economyPopUpWrapper.current.contains(event.target))
    if (
      this.travellerDivRef.current &&
      !this.travellerDivRef.current.contains(event.target)
    ) {
      this.setState({
        isTravelersPopupVisible: false,
        openCabinClassList: false,
        paxAdultValue: this.state.travellersObjOrigin.adults,
        paxChildrenValue: this.state.travellersObjOrigin.child,
        paxInfantValue: this.state.travellersObjOrigin.infants,
      });
    }
    if (
      this.economyPopUpWrapper.current &&
      !this.economyPopUpWrapper.current.contains(event.target)
    ) {
      this.setState({
        openCabinClassList: false,
        openCabinClassListOne: false,
        // SelectedClassValue: { ...this.state.travellersObjOrigin.originalSelectedClass }
      });
    }

    if (
      this.cabinPopUpWrapperTwo.current &&
      !this.cabinPopUpWrapperTwo.current.contains(event.target)
    ) {
      this.setState({
        openCabinClassListTwo: false,
        // SelectedClassValue: { ...this.state.travellersObjOrigin.originalSelectedClass }
      });
    }

    if (
      this.passengerDropdownWrapper.current &&
      !this.passengerDropdownWrapper.current.contains(event.target)
    ) {
      this.setState({
        openPaxList: false,
      });
    }
    if (
      this.departureListWrapper.current &&
      !this.departureListWrapper.current.contains(event.target)
    ) {
      this.setState({ expandDepartureBoolean: false });
    }
    if (
      this.returnListWrapper.current &&
      !this.returnListWrapper.current.contains(event.target)
    ) {
      this.setState({ expandGoingToBoolean: false });
    }
    if (
      this.multicityDepartureWrapper.current &&
      !this.multicityDepartureWrapper.current.contains(event.target)
    ) {
      const multicityFlightData = JSON.parse(
        JSON.stringify(this.state.multicityFlightData)
      );
      multicityFlightData[
        this.state.selectedDepartureIndex
      ].isDeparture = false;
      this.setState((prevState) => {
        return {
          ...prevState,
          multicityFlightData,
          expandGoingToBoolean: false,
          selectedDepartureIndex: null,
        };
      });
    }

    if (
      this.multicityReturnWrapper.current &&
      !this.multicityReturnWrapper.current.contains(event.target)
    ) {
      const multicityFlightData = JSON.parse(
        JSON.stringify(this.state.multicityFlightData)
      );
      multicityFlightData[this.state.selectedGoingToIndex].isGoingTo = false;
      this.setState((prevState) => {
        return {
          ...prevState,
          multicityFlightData,
          expandGoingToBoolean: false,
          selectedGoingToIndex: null,
        };
      });
    }
  };

  handleTabInside = (e) => {
    if (e.key !== "Tab") {
      return;
    }
    this.handleClickOutside(e);
  };

  onChangeSetDepartureGoingToValue = (value, type, index) => {
    console.log(value, type, index, "type");
    if (type === "departure") {
      if (index !== undefined) {
        const multicityFlightData = JSON.parse(
          JSON.stringify(this.state.multicityFlightData)
        );
        multicityFlightData[index]["org"] = value;
        multicityFlightData[index]["departureValue"] = value;
        this.setState((prevState) => {
          return {
            ...prevState,
            multicityFlightData,
          };
        });
      } else {
        this.setState(
          { departureValue: value, departureAirportCode: "" },
          () => {
            if (this.state.isError.departure === true) {
              this.validateErrorMsg();
            }
            if (value.length === 0) {
              this.setState({ getDepartureSuggestionList: [] });
            }
          }
        );
      }
    } else {
      if (index !== undefined) {
        const multicityFlightData = JSON.parse(
          JSON.stringify(this.state.multicityFlightData)
        );
        multicityFlightData[index]["dest"] = value;
        multicityFlightData[index]["goingToValue"] = value;
        this.setState((prevState) => {
          return {
            ...prevState,
            multicityFlightData,
          };
        });
      } else {
        this.setState({ goingToValue: value, goingToAirportCode: "" }, () => {
          if (this.state.isError.goingTo === true) {
            this.validateErrorMsg();
            if (value.length === 0)
              this.setState({ getGoingToSuggestionList: [] });
          }
        });
      }
    }

    if (type === "departure") {
      this.props.getAutoSuggestData(value, type, "change");
      this.setState({ expandDepartureBoolean: true });
    } else {
      this.props.getAutoSuggestData(value, type, "change");
      this.setState({ expandGoingToBoolean: true });
    }
  };

  onchangeVisibility = (bool, type, index) => {
    if (type === "goingTo") {
      this.setState(
        { expandReturnDateBoolean: bool, expandDepartureDateBoolean: false },
        () => {
          if (this.state.isOnewaySearch === true) {
            this.setState({ isOnewaySearch: false });
          }
        }
      );
    } else {
      if (index !== undefined) {
        const multicityFlightData = JSON.parse(
          JSON.stringify(this.state.multicityFlightData)
        );
        multicityFlightData[index]["expandDepartureDateBoolean"] = bool;
        this.setState((prevState) => {
          return {
            ...prevState,
            multicityFlightData,
            expandGoingToDateBoolean: false,
          };
        });
      } else {
        this.setState({
          expandReturnDateBoolean: false,
          expandDepartureDateBoolean: bool,
        });
      }
    }
  };

  validateErrorMsg = () => {
    const mapDispatch = {
      departure: commonFunction.isValueEmpty(this.state.departureValue)
        ? true
        : false,
      goingTo: commonFunction.isValueEmpty(this.state.goingToValue)
        ? true
        : this.state.departureValue === this.state.goingToValue
        ? true
        : false,
      departureDate: commonFunction.isValueEmpty(this.state.departureDate)
        ? true
        : false,
      goingToDate: commonFunction.isValueEmpty(this.state.returnDate)
        ? true
        : false,
    };
    this.setState({ isError: mapDispatch });
  };

  onClickSetDepartureGoingToValue = (
    city,
    airPortCode,
    airPortName,
    type,
    index
  ) => {
    if (type === "departure") {
      if (this?.state?.isMultiCitySearch) {
        const multicityFlightData = JSON.parse(
          JSON.stringify(this.state.multicityFlightData)
        );
        multicityFlightData[index]["org"] = airPortCode;
        multicityFlightData[index]["departureValue"] =
          city + " - (" + airPortCode + ")";
        this.setState((prevState) => {
          return {
            ...prevState,
            multicityFlightData,
            selectedDepartureIndex: null,
          };
        });
      } else {
        this.setState(
          {
            departureValue: city + " - (" + airPortCode + ")",
            departureAirportCode: airPortCode,
            departureCity: city,
          },
          () => {
            if (this.state.isError.departure === true) {
              this.validateErrorMsg();
            }
          }
        );
      }
    } else {
      if (this?.state?.isMultiCitySearch) {
        const multicityFlightData = JSON.parse(
          JSON.stringify(this.state.multicityFlightData)
        );
        multicityFlightData[index]["dest"] = airPortCode;
        multicityFlightData[index + 1]
          ? (multicityFlightData[index + 1]["org"] = airPortCode)
          : "",
          (multicityFlightData[index]["goingToValue"] =
            city + " - (" + airPortCode + ")"),
          multicityFlightData[index + 1]
            ? (multicityFlightData[index + 1]["departureValue"] =
                city + " - (" + airPortCode + ")")
            : "",
          this.setState((prevState) => {
            return {
              ...prevState,
              multicityFlightData,
              selectedGoingToIndex: null,
            };
          });
      } else {
        this.setState(
          {
            goingToValue: city + " - (" + airPortCode + ")",
            goingToAirportCode: airPortCode,
            returnCity: city,
          },
          () => {
            if (this.state.isError.goingTo === true) {
              this.validateErrorMsg();
            }
          }
        );
      }
    }
  };

  onClickSwap = () => {
    if (this.state.departureValue || this.state.goingToValue) {
      let departureValue = this.state.departureValue;
      let departureAirportCode = this.state.departureAirportCode;
      let departureCity = this.state.departureCity;
      this.setState({
        departureValue: this.state.goingToValue,
        goingToValue: departureValue,
        departureAirportCode: this.state.goingToAirportCode,
        goingToAirportCode: departureAirportCode,
        departureCity: this.state.returnCity,
        returnCity: departureCity,
      });
    }
  };
  onChangeDepartureGoingDateValue = (value, type, index) => {
    if (type === "goingTo") {
      let dayDifference = differenceInCalendarDays(
        new Date(value),
        new Date(this.state.departureDate)
      );
      if (dayDifference < 0) {
        this.setState({
          isOnewaySearch: true,
          returnDate: format(addDays(new Date(), 7), "dd-LLL-yyyy"),
        });
      } else {
        this.setState({ returnDate: format(new Date(value), "dd-LLL-yyyy") });
      }
    } else {
      if (index !== undefined) {
        const multicityFlightData = JSON.parse(
          JSON.stringify(this.state.multicityFlightData)
        );
        value = format(value, "dd-LLL-yyyy");
        for (let ind = 0; ind < multicityFlightData.length; ind++) {
          if (ind == index) {
            multicityFlightData[ind]["odt"] = value;
          }
          if (ind > index) {
            let temp = JSON.parse(JSON.stringify(value));
            if (
              isBefore(
                new Date(multicityFlightData[ind]["odt"]),
                new Date(temp)
              )
            )
              multicityFlightData[ind]["odt"] = value;
            multicityFlightData[ind]["disabledDate"] = value;
          }
        }

        let returnDate = this.state.returnDate;

        let dayDifference = differenceInCalendarDays(
          new Date(this.state.returnDate),
          new Date(value)
        );
        if (dayDifference < 0) {
          returnDate = format(addDays(new Date(value), 7), "dd-LLL-yyyy");
        }
        multicityFlightData[index]["odt"] = format(
          new Date(value),
          "dd-LLL-yyyy"
        );
        multicityFlightData[index]["expandDepartureDateBoolean"] = false;
        setTimeout(() => {
          this.setState((prevState) => {
            return {
              ...prevState,
              multicityFlightData,
              returnDate,
            };
          });
        }, 10);
      } else {
        let returnDate = this.state.returnDate;
        let dayDifference = differenceInCalendarDays(
          new Date(this.state.returnDate),
          new Date(value)
        );
        if (/* this.state.isOnewaySearch && */ dayDifference < 0) {
          returnDate = format(addDays(new Date(value), 7), "dd-LLL-yyyy");
        }
        this.setState({
          departureDate: format(new Date(value), "dd-LLL-yyyy"),
          returnDate,
        });
      }
    }
  };

  onclickFlightAutoComplete = (type, key, i) => {
    if (type === "departure") {
      if (i !== undefined && key !== undefined) {
        const multicityFlightData = JSON.parse(
          JSON.stringify(this.state?.multicityFlightData)
        );
        multicityFlightData[i][key] = true;
        multicityFlightData[i]["departureValue"] = "";
        multicityFlightData[i]["org"] = "";
        this.setState((prevState) => {
          return {
            ...prevState,
            multicityFlightData,
            selectedDepartureIndex: i,
            selectedGoingToIndex: null,
          };
        });
      } else {
        this.setState({ departureValue: "" }, () => {
          this.props.getAutoSuggestData(
            this.state.departureValue,
            type,
            "click"
          );
        });
      }
    } else {
      if (i !== undefined && key !== undefined) {
        const multicityFlightData = JSON.parse(
          JSON.stringify(this.state.multicityFlightData)
        );
        multicityFlightData[i][key] = true;
        multicityFlightData[i]["goingToValue"] = "";
        multicityFlightData[i]["dest"] = "";
        this.setState((prevState) => {
          return {
            ...prevState,
            multicityFlightData,
            selectedGoingToIndex: i,
            selectedDepartureIndex: null,
          };
        });
      } else {
        this.setState({ goingToValue: "" }, () => {
          this.props.getAutoSuggestData(this.state.goingToValue, type, "click");
        });
      }
    }
  };

  onTravellersClickHandler = () => {
    this.setState({ isTravelersPopupVisible: true });
  };

  onClickChangePaxNumber = (pax, value, type) => {
    if (pax === "adult") {
      if (
        +value > 0 &&
        +this.state.paxChildrenValue + value <= 9 &&
        +this.state.paxChildrenValue + value > 0
      ) {
        this.setState({ paxAdultValue: value }, () => {
          if (type === "minus") {
            if (+this.state.paxInfantValue > value) {
              let paxInfantValue = +this.state.paxInfantValue;
              this.setState({ paxInfantValue: paxInfantValue - 1 });
            }
          }
        });
      }
    } else if (pax === "children") {
      if (
        +value + +this.state.paxAdultValue <= 9 &&
        +value + +this.state.paxAdultValue > 0
      ) {
        this.setState({ paxChildrenValue: +value });
      } else if (+value + this.state.paxAdultValue > 9 && type === "minus") {
        this.setState({ paxChildrenValue: 9 - this.state.paxAdultValue });
      }
    } else if (pax === "infant") {
      // if (value > (+this.state.paxAdultValue)) {
      //     this.setState({ paxInfantValue: +(--value) });
      // } else {
      //     this.setState({ paxInfantValue: +value });
      // }
      if (+value >= 0 && +value <= this.state.paxAdultValue) {
        this.setState({ paxInfantValue: +value });
      } else if (+value > this.state.paxAdultValue && type === "minus") {
        this.setState({ paxInfantValue: +this.state.paxAdultValue });
      }
    }
  };

  checkValidation = (item) => {
    let isValid = true;
    const { multicityFlightData = [] } = item;
    multicityFlightData.map((data, index) => {
      let errorObj = {};
      if (data["org"] === "") {
        isValid = false;
        errorObj["org"] = "Enter Origin City";
      }
      if (data["dest"] === "") {
        isValid = false;
        errorObj["dest"] = "Enter Destination City";
      }

      if (data["org"] === data["dest"] && data["dest"] !== "") {
        isValid = false;
        errorObj["dest"] = "Origin and destination cannot be same";
      }
      data.error = errorObj;
    });
    return { isValid, data: multicityFlightData };
  };

  onClickSearchFlight = () => {
    if (this.state.isMultiCitySearch) {
      let { isValid, data } = this.checkValidation(this.state);
      this.setState((prevState) => {
        return {
          ...prevState,
          multicityFlightData: data,
          isValid,
        };
      });
    }
    const mapDispatch = {
      departure: commonFunction.isValueEmpty(this.state.departureValue)
        ? true
        : !this.state.departureAirportCode
        ? true
        : false,
      goingTo: commonFunction.isValueEmpty(this.state.goingToValue)
        ? true
        : !this.state.goingToAirportCode
        ? true
        : this.state.departureValue === this.state.goingToValue
        ? true
        : false,
      departureDate: commonFunction.isValueEmpty(this.state.departureDate)
        ? true
        : false,
      goingToDate: commonFunction.isValueEmpty(this.state.returnDate)
        ? true
        : false,
    };
    this.setState({ isError: mapDispatch }, () => {
      let Validate = true;
      for (const [key, value] of Object.entries(this.state.isError)) {
        if (value === true) {
          Validate = false;
          break;
        }
      }
      let arrivalDate = "";
      let departureDateArr = !commonFunction.isValueEmpty(
        this.state.departureDate
      )
        ? this.state.departureDate.split("/")
        : "";
      let departureDate = !commonFunction.isValueEmpty(departureDateArr)
        ? format(new Date(this.state.departureDate), "yyyy-MM-dd")
        : "";
      if (this.state.isOnewaySearch === false) {
        let arrivalDateArr = !commonFunction.isValueEmpty(this.state.returnDate)
          ? this.state.returnDate.split("/")
          : "";
        arrivalDate = !commonFunction.isValueEmpty(arrivalDateArr)
          ? format(new Date(this.state.returnDate), "yyyy-MM-dd")
          : "";
      }
      let roundTripAdvanceSearchFlightData = [];
      if (
        !this.state.isMultiCitySearch &&
        !this.state.isOnewaySearch &&
        this.state.openAirlines
      ) {
        console.log(
          "roundTripAdvanceSearchFlightData:",
          roundTripAdvanceSearchFlightData
        );
        roundTripAdvanceSearchFlightData = [
          {
            org: this.state.departureAirportCode,
            dest: this.state.goingToAirportCode,
            odt: departureDate,
            advancesearch: {
              airlines: JSON.stringify(
                this.props.selectedAirlines &&
                  this.props.selectedAirlines
                    .filter((option) => option.isChecked)
                    .map((item) => item.value)
              ),
              fcs: JSON.stringify(
                this.props.selectedRbdClassOne &&
                  this.props.selectedRbdClassOne
                    .filter((option) => option.isChecked)
                    .map((item) => item.value)
              ),
              dtym: "",
              cabinclass:
                this.state.SelectedAdvanceSearcheRoundClassValueOne.id,
            },
          },
          {
            org: this.state.goingToAirportCode,
            dest: this.state.departureAirportCode,
            odt: arrivalDate,
            advancesearch: {
              airlines: JSON.stringify(
                this.props.selectedAirlines &&
                  this.props.selectedAirlines
                    .filter((option) => option.isChecked)
                    .map((item) => item.value)
              ),
              fcs: JSON.stringify(
                this.props.selectedRbdClassTwo &&
                  this.props.selectedRbdClassTwo
                    .filter((option) => option.isChecked)
                    .map((item) => item.value)
              ),
              dtym: "",
              cabinclass: this.state.SelectedAdvanceSearchRoundClassValueTwo.id,
            },
          },
        ];
      }

      let multicityData = JSON.parse(
        JSON.stringify(this.state.multicityFlightData)
      );
      // if (this.state.isMultiCitySearch && this.state.isAdvanceSearch) {
      multicityData.forEach((element) => {
        element.odt = format(new Date(element.odt), "yyyy-MM-dd");
        if (typeof element.advancesearch.airlines == "object") {
          element.advancesearch.airlines = JSON.stringify(
            element.advancesearch.airlines &&
              element?.advancesearch?.airlines
                .filter((option) => option.isChecked)
                .map((item) => item.value)
          );
        }
        if (typeof element.advancesearch.fcs == "object") {
          element.advancesearch.fcs = JSON.stringify(
            element.advancesearch.fcs &&
              element.advancesearch?.fcs
                .filter((option) => option.isChecked)
                .map((item) => item.value)
          );
        }
        element.advancesearch.dtym =
          element.advancesearch?.dtym &&
          element.advancesearch.dtym
            .filter((option) => option.isChecked)
            .map((item) => item.value);

        if (element?.advancesearch?.cabinclass?.id) {
          element.advancesearch.cabinclass =
            element?.advancesearch?.cabinclass?.id;
        }
      });
      // }

      let multicity_data = multicityData;
      console.log("multicity_data:23", multicity_data);

      let urlQuery = {
        from: this.state.departureAirportCode,
        to: this.state.goingToAirportCode,
        type: this.state.isOnewaySearch
          ? 1
          : this.state.isMultiCitySearch
          ? 3
          : 2,
        class: this.state.travellersObjOrigin.originalSelectedClass.id,
        adults: this.state.paxAdultValue,
        guests: this.state.guest,
        child: this.state.paxChildrenValue,
        infants: this.state.paxInfantValue,
        departure: departureDate,
        arrival: arrivalDate,
        fromCity: this.state.departureCity,
        toCity: this.state.returnCity,
        multicity: this.state.isMultiCitySearch
          ? JSON.stringify(multicity_data)
          : [],
        airlines: JSON.stringify(
          this.props.selectedAirlines &&
            this.props.selectedAirlines
              .filter((option) => option.isChecked)
              .map((item) => item.value)
        ),
        splfare: this.props.FareType
          ? this.props.FareType.filter((option) => option.isChecked).map(
              (item) => item.value
            )
          : "",
        departure_time: this.state.dtym,
        supplier: JSON.stringify(
          this.props.selectedSupplier &&
            this.props.selectedSupplier
              .filter((option) => option.isChecked)
              .map((item) => item.value)
        ),
        rbd_class: JSON.stringify(
          this.props.selectedRbdClass &&
            this.props.selectedRbdClass
              .filter((option) => option.isChecked)
              .map((item) => item.value)
        ),
        isAdvanceSearch: this.state.openAirlines,
        AdvanceOneWayClass:
          this.state.SelectedAdvanceSearchOneWayClassValue?.id,
        roundTripAdvanceSearchFlightData: roundTripAdvanceSearchFlightData
          ? JSON.stringify(roundTripAdvanceSearchFlightData)
          : [],
      };
      // console.log("urlQuery",urlQuery);

      if (this.state.isValid && this.state.isMultiCitySearch === true) {
        cf.redirectTo("flight/search", urlQuery);
      } else {
        console.log("fgkfhgfjhgfkjt", this.state.isMultiCitySearch);
        delete urlQuery.multicity;
        console.log("aartttttttttttiyt", urlQuery);

        if (Validate === true && this.state.isMultiCitySearch === false) {
          commonFunction.redirectTo("flight/search", urlQuery);
        }
      }
    });
  };

  onDoneBtnClickHandler = () => {
    // console.log("originalSelectedClass123",this.state.SelectedClassValue)

    this.setState(
      {
        travellersObjOrigin: {
          adults: this.state.paxAdultValue,
          child: this.state.paxChildrenValue,
          infants: this.state.paxInfantValue,

          originalSelectedClass: {
            ...this.state?.SelectedClassValue,
          },
        },
        isTravelersPopupVisible: false,
      },
      () => {
        console.log(
          "originalSelectedClass",
          this.state.travellersObjOrigin.originalSelectedClass
        );
      }
    );
  };

  onClickOpenCabinClassList = () => {
    let temp = [...this.props.selectedRbdClass];
    temp.forEach((ele) => {
      ele.isChecked = false;
    });

    this.props.setrbdOptions(temp);
    if (this.state.openCabinClassList === false) {
      this.setState({ openCabinClassList: true });
    } else if (this.state.openCabinClassList === true) {
      this.setState({ openCabinClassList: false });
    }
  };

  // onClickSwap = () => {
  //     if (!commonFunction.isValueEmpty(this.state.departureValue) && !commonFunction.isValueEmpty(this.state.goingToValue)) {
  //         this.setState({ departureValue: this.state.goingToValue, goingToValue: this.state.departureValue });
  //     }
  // }

  cabinClassSelectHandler = (element) => {
    console.log("element", element);
    this.setState(
      {
        SelectedClassValue: {
          label: element.label,
          value: element.value,
          id: element.id,
        },
        openCabinClassList: false,
      },
      () => {
        console.log("SelectedClassValue", this.state.SelectedClassValue);
      }
    );
  };
  deleteReturnDateHandler = () => {
    this.setState({ isOnewaySearch: true, expandReturnDateBoolean: false });
  };

  removeReturnDateHandler = (e) => {
    if (e.key !== "Enter") {
      return;
    }
    this.deleteReturnDateHandler();
  };

  highlightData(id, parentElement) {
    let innerContent = document.getElementById(parentElement).children;
    for (let i = 0; i < innerContent.length; i++) {
      let selectedElement = innerContent[i];
      selectedElement.style.backgroundColor = i == id ? "#ccc" : "#fff";
    }
    innerContent[id].scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start",
    });
  }

  onKeyDownArrow = (event, parentClassId, list, type) => {
    let code = "";
    let name = "";
    let indexDropdown = this.state.indexDropdown;
    switch (event.which) {
      case 38: // up
        indexDropdown--;
        if (indexDropdown < 0) {
          indexDropdown = 0;
        }
        this.highlightData(indexDropdown, parentClassId);
        code =
          list.length >= indexDropdown
            ? `${list[indexDropdown].AIRPORT_CODE}`
            : "";
        name =
          list.length >= indexDropdown
            ? `${list[indexDropdown].CITY_NAME}`
            : "";
        search_type =
          list.length >= indexDropdown
            ? `${
                list[indexDropdown].search_type
                  ? list[indexDropdown].search_type
                  : 1
              }`
            : "";
        break;
      case 40: // down
        indexDropdown++;
        if (indexDropdown >= list.length - 1) {
          indexDropdown = list.length - 1;
        }
        this.highlightData(indexDropdown, parentClassId);
        code =
          list.length >= indexDropdown
            ? `${list[indexDropdown].AIRPORT_CODE}`
            : "";
        name =
          list.length >= indexDropdown
            ? `${list[indexDropdown].CITY_NAME}`
            : "";
        search_type =
          list.length >= indexDropdown
            ? `${
                list[indexDropdown].search_type
                  ? list[indexDropdown].search_type
                  : 1
              }`
            : "";
        break;

      case 13: //enter
        if (this.state.code && this.state.name) {
          this.onClickSetDepartureGoingToValue(
            this.state.name,
            this.state.code,
            type
          );
        }
        if (type === "departure") {
          this.setState({ expandDepartureBoolean: false });
        }
        if (type === "goingTo") {
          this.setState({ expandGoingToBoolean: false });
        }
        indexDropdown = -1;
        break;
      case 9: //enter
        if (this.state.code && this.state.name) {
          this.onClickSetDepartureGoingToValue(
            this.state.name,
            this.state.code,
            type
          );
        }
        if (type === "departure") {
          this.setState({ expandDepartureBoolean: false });
        }
        if (type === "goingTo") {
          this.setState({ expandGoingToBoolean: false });
        }
        indexDropdown = -1;
        break;
      default:
    }
    this.setState({ code: code, name: name, indexDropdown: indexDropdown });
  };

  modifySearchKeyDownHandler = (e) => {
    if (e.key !== "Enter") {
      return;
    }
    this.onClickSearchFlight();
  };

  onSwapKeyDownHandler = (e) => {
    if (e.key !== "Enter") {
      return;
    }
    this.onClickSwap();
  };

  multicityTab = () => {
    this.setState({
      isOnewaySearch: false,
      isMultiCitySearch: true,
    });
  };

  AddFlightButton = () => {
    console.log(
      "JSON.parse(JSON.stringify(this.state.multicityFlightData)",
      JSON.parse(JSON.stringify(this.state.multicityFlightData))
    );
    const multicityFlightData = JSON.parse(
      JSON.stringify(this.state.multicityFlightData)
    );
    let index = multicityFlightData.length - 1;
    let org = multicityFlightData[index].dest;
    let departureValue = multicityFlightData[index].goingToValue;
    this.setState((prevState) => ({
      multicityFlightData: [
        ...prevState.multicityFlightData,
        {
          org: org ? org : "",
          dest: "",
          departureValue: departureValue ? departureValue : "",
          odt: multicityFlightData[index].odt,
          disabledDate: multicityFlightData[index].disabledDate,
          advancesearch: {
            airlines: airline,
            fcs: rbdClass,
            dtym: "",
            cabinclass: { label: "Economy", id: 1 },
          },
        },
      ],
    }));
  };
  RemoveFlightObject = (index) => {
    const items = this.state.multicityFlightData.filter(
      (item, i) => i !== index
    );
    this.setState((prevState) => {
      return {
        ...prevState,
        multicityFlightData: items,
      };
    });
  };

  onClickAirlines = () => {
    if (!this.state.openAirlines) {
      this.setState((prevState) => {
        return {
          ...prevState,
          openAirlines: true,
        };
      });
    } else {
      this.setState((prevState) => {
        return {
          ...prevState,
          openAirlines: false,
        };
      });
    }
  };

  onClickOpenPassangerList = () => {
    if (this.state.openPaxList === false) {
      this.setState({ openPaxList: true });
    } else if (this.state.openPaxList === true) {
      this.setState({ openPaxList: false });
    }
  };

  onChangeAdvOneWayClassValue = (element) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        SelectedAdvanceSearchOneWayClassValue: {
          label: element.label,
          id: element.id,
        },
      };
    });
  };

  onRBDClick = () => {
    console.log("🚀 ~ file: index.js:499 ~ Theme2 ~ onRBDClick:");

    this.setState({ SelectedAdvanceSearchOneWayClassValue: {} });
  };

  onRBDClickOne = () => {
    this.setState({ SelectedAdvanceSearcheRoundClassValueOne: {} });
  };

  onRBDClickTwo = () => {
    this.setState({ SelectedAdvanceSearchRoundClassValueTwo: {} });
  };

  onClickOpenCabinClassListOne = () => {
    let temp = [...this.props.selectedRbdClass];
    temp.forEach((ele) => {
      ele.isChecked = false;
    });

    this.props.setrbdOptions(temp);

    if (this.state.openCabinClassListOne === false) {
      this.setState({ openCabinClassListOne: true });
    } else if (this.state.openCabinClassListOne === true) {
      this.setState({ openCabinClassListOne: false });
    }
  };

  onClickOpenCabinClassListTwo = () => {
    if (this.state.openCabinClassListTwo === false) {
      this.setState({ openCabinClassListTwo: true });
    } else if (this.state.openCabinClassListTwo === true) {
      this.setState({ openCabinClassListTwo: false });
    }
  };

  onChangeAdvRoundClassValueOne = (element) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        SelectedAdvanceSearcheRoundClassValueOne: {
          label: element.label,
          id: element.id,
        },
      };
    });
  };

  onChangeAdvRoundClassValueTwo = (element) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        SelectedAdvanceSearchRoundClassValueTwo: {
          label: element.label,
          id: element.id,
        },
      };
    });
  };

  onRbDClickMulti = (index) => {
    const { multicityFlightData } = this.state;
    const updatedData = JSON.parse(JSON.stringify(multicityFlightData));

    updatedData[index] = {
      ...updatedData[index],
      advancesearch: {
        ...updatedData[index]?.advancesearch,
        cabinclass: {},
      },
    };
    this.setState({ multicityFlightData: updatedData });
  };
  // Parent component
  multiSelectAdvanceRBDClassDropdown = (index) => {
    const { multicityFlightData } = this.state;
    const options = multicityFlightData[index]?.advancesearch?.fcs;

    return (
      <MultiSelectDropDown
        style={this.props.styles}
        inputPlaceHolder={"Select RBD Class"}
        dropdownInputPlaceHolder={"Type here RBD"}
        options={options}
        setoptions={(newOptions) => {
          const updatedData = JSON.parse(JSON.stringify(multicityFlightData));
          updatedData[index] = {
            ...updatedData[index],
            advancesearch: {
              ...updatedData[index]?.advancesearch,
              fcs: newOptions,
            },
          };
          this.setState({ multicityFlightData: updatedData });
        }}
      />
    );
  };

  multiSelectAdvanceAirlineClassDropdown = (index) => {
    const { multicityFlightData } = this.state;
    const options = multicityFlightData[index]?.advancesearch?.airlines;
    // const options = this.state.airlineList

    return (
      <MultiSelectDropDown
        style={this.props.styles}
        inputPlaceHolder={"Select Airline"}
        dropdownInputPlaceHolder={"Type here Airline"}
        options={options}
        setoptions={(newOptions) => {
          const updatedData = JSON.parse(JSON.stringify(multicityFlightData));
          updatedData[index] = {
            ...updatedData[index],
            advancesearch: {
              ...updatedData[index]?.advancesearch,
              airlines: newOptions,
            },
          };
          this.setState({ multicityFlightData: updatedData });
        }}
      />
    );
  };

  updateMulticityDepartureTime = (index) => {
    const { multicityFlightData } = this.state;
    return (
      <MultiSuppilerDropDownoption
        options={DepartureTime}
        setoptions={(newOptions) => {
          const updatedData = JSON.parse(JSON.stringify(multicityFlightData));
          updatedData[index] = {
            ...updatedData[index],
            advancesearch: {
              ...updatedData[index]?.advancesearch,
              dtym: newOptions,
            },
          };
          this.setState({ multicityFlightData: updatedData });
        }}
        inputPlaceHolder={"Departure Time"}
        style={this.props.styles}
        box={this.box}
      />
    );
  };

  onChangeClassValue = (element, index) => {
    if (index !== undefined) {
      const multicityFlightData = JSON.parse(
        JSON.stringify(this.state.multicityFlightData)
      );
      multicityFlightData[index].advancesearch.cabinclass = {
        label: element.label,
        id: element.id,
      };

      setTimeout(() => {
        this.setState((prevState) => {
          return {
            ...prevState,
            multicityFlightData,
            selectedClassIndex: null,
          };
        });
      }, 10);
    } else {
      this.setState((prevState) => {
        return {
          ...prevState,
          SelectedClassValue: {
            label: element.label,
            id: element.id,
          },
        };
      });
    }
  };

  onClickOpenCabinClassListMulticity = (index) => {
    console.log("index==>", index);
    this.setState({ selectedClassIndex: index });
    const { multicityFlightData } = this.state;
    const updatedData = JSON.parse(JSON.stringify(multicityFlightData));
    let newoption = updatedData[index].advancesearch.fcs;
    newoption.forEach((ele) => {
      ele.isChecked = false;
    });

    updatedData[index] = {
      ...updatedData[index],
      advancesearch: {
        ...updatedData[index]?.advancesearch,
        fcs: newoption,
      },
    };
    this.setState({ multicityFlightData: updatedData });

    // this.setState({ selectedClassIndex: index });
  };

  render() {
    return (
      <div
        className={`"flex flex-row w-full mx-auto gray_color newcontainer ${this.props.styles.justify_around}"`}
      >
        <div className={this.props.styles.flightsearchpage_widget}>
          <div className={this.props.styles.flightModify_wrap}>
            <div class={this.props.styles.flight_way_tab}>
              <div class={this.props.styles.flight_way_btngrp}>
                <button
                  className={
                    this.state.isOnewaySearch &&
                    this?.state?.isMultiCitySearch === false
                      ? this.props.styles.active_way
                      : this.props.styles.button_style
                  }
                  onClick={() => {
                    this.setState({
                      isOnewaySearch: true,
                      isMultiCitySearch: false,
                      expandGoingToDateBoolean: false,
                      expandDepartureDateBoolean: false,
                    });
                  }}
                >
                  <>
                    <input
                      type="radio"
                      value="multi-city"
                      checked={this.state.isOnewaySearch}
                    />
                    <label>One-Way</label>
                  </>
                  {/* <svg width="20px" height="24" viewBox="0 0 200 200"><polygon points="180.8,40.25 19.2,40.25 100.202,166.5 "></polygon></svg> */}
                </button>
                <button
                  className={
                    this.state.isOnewaySearch === false &&
                    this?.state?.isMultiCitySearch === false
                      ? this.props.styles.active_way
                      : this.props.styles.button_style
                  }
                  onClick={() => {
                    this.setState({
                      isOnewaySearch: false,
                      isMultiCitySearch: false,
                      goingToDateValue: commonFunction.getDateWithFormat(
                        addDays(new Date(this.state.departureDateValue), 7),
                        this?.props?.dateFormat
                      ),
                    });
                  }}
                >
                  <>
                    <input
                      type="radio"
                      value="multi-city"
                      checked={!this.state.isOnewaySearch}
                    />
                    <label>Round-Trip</label>
                  </>
                  {/* <svg width="20px" height="24" viewBox="0 0 200 200"><polygon points="180.8,40.25 19.2,40.25 100.202,166.5 "></polygon></svg> */}
                </button>

                <button
                  className={
                    this.state.isOnewaySearch === false &&
                    this?.state?.isMultiCitySearch === true
                      ? this.props.styles.active_way
                      : this.props.styles.button_style
                  }
                  onClick={() => {
                    this.multicityTab();
                  }}
                >
                  <>
                    <input
                      type="radio"
                      value="multi-city"
                      checked={this.state.isMultiCitySearch}
                    />
                    <label>Multi-City</label>
                  </>
                  {/* <svg width="20px" height="24" viewBox="0 0 200 200"><polygon points="180.8,40.25 19.2,40.25 100.202,166.5 "></polygon></svg> */}
                </button>
                <div className={this.props.styles.advance_add}>
                  <div
                    className={this.props.styles.advance_search_card_container}
                    style={{ cursor: "pointer" }}
                    onClick={() => this.onClickAirlines()}
                    // id="search_button"
                  >
                    <button
                      type="button"
                      // id="advanceSearchButton"
                      className={this.props.styles.traveller_button}
                    >
                      {this.state.openAirlines ? "-" : "+"}
                    </button>
                    <span className={this.props.styles.guesttext}>
                      Advanced Search
                    </span>
                  </div>
                </div>
                {/* <button
                        type="button"
                        onClick={() => this.onClickAirlines()}
                        className={this.props.styles.button_style}
                        id="advanceSearchButton"
                      >
                   {this.state.openAirlines ? "-" : "+"}
                   Advanced Search
                  </button> */}
              </div>
            </div>
            {this?.state?.isMultiCitySearch === true ? (
              <>
                {!this.state.openAirlines && (
                  <div
                    className={
                      this.props.styles.flightsearchpage_widget_multicity
                    }
                  >
                    <div className={this.props.styles.multicity_fare_container}>
                      <div
                        className={this.props.styles.modifySearchWidget_divider}
                      >
                        {this.state?.multicityFlightData.map((data, i) => {
                          return (
                            <div>
                              <ModifySearchForm
                                style={this.props.styles}
                                state={this.state}
                                data={data}
                                index={i}
                                onclickFlightAutoComplete={
                                  this.onclickFlightAutoComplete
                                }
                                setState={this.setState}
                                onClickSetDepartureGoingToValue={
                                  this.onClickSetDepartureGoingToValue
                                }
                                getGoingToSuggestionList={
                                  this.props.getGoingToSuggestionList
                                }
                                getDepartureSuggestionList={
                                  this.props.getDepartureSuggestionList
                                }
                                onChangeSetDepartureGoingToValue={
                                  this.onChangeSetDepartureGoingToValue
                                }
                                onchangeVisibility={this.onchangeVisibility}
                                dateFormat={this.props.dateFormat}
                                onChangeDepartureGoingDateValue={
                                  this.onChangeDepartureGoingDateValue
                                }
                                todaysDate={todaysDate}
                                onSwapKeyDownHandler={this.onSwapKeyDownHandler}
                                onClickSwap={this.onClickSwap}
                                onKeyDownArrow={this.onKeyDownArrow}
                                multicityReturnWrapper={
                                  this.multicityReturnWrapper
                                }
                                multicityDepartureWrapper={
                                  this.multicityDepartureWrapper
                                }
                                RemoveFlightObject={this.RemoveFlightObject}
                              />
                            </div>
                          );
                        })}
                      </div>
                      {/* <div className={this.props.styles.fare_type_bx}>
                  <div className={`${this.props.styles.flightautocomplemodifysfare} ${this.props.styles.wd_30}`}>
                          <div className={this.props.styles.flightfares}>
                      <label>Select Fare Type</label>
                      <div className={this.props.styles.flightmainfare}>
                        <span>
                        <svg width="20px" height="20px" viewBox="0 0 200 200"><g><path fill-rule="evenodd" fill="#01445F" d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"></path></g></svg>
                        </span>
                        <label>Select Fare Type</label>
                        <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9"><path fill-rule="evenodd" fill="#01445F" d="M11.59 1.135c.55-.413 1.102-.404 1.515.021.412.425.403 1.104.735 1.517L7.729 7.875l-.747-.769.748.772a1.072 1.072 0 0 1-1.519-.023l-.035-.038-5.25-5.144a1.074 1.074 0 0 1-.021-1.517 1.07 1.07 0 0 1 1.515-.021l4.565 4.473 4.605-4.473z"></path></svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </div> */}
                    </div>
                    {this.state?.multicityFlightData.length <= 5 && (
                      <div class={this.props.styles.search_button_section}>
                        <button onClick={this.AddFlightButton}>
                          {" "}
                          Add More flight(
                          {this?.state?.multicityFlightData.length <= 2
                            ? 4
                            : this?.state?.multicityFlightData.length === 3
                            ? 3
                            : this?.state?.multicityFlightData.length === 4
                            ? 2
                            : 1}
                          Max) +{" "}
                        </button>
                      </div>
                    )}
                    <div
                      className={this.props.styles.flightautocomplemodifymain}
                    >
                      <div
                        className={this.props.styles.flightautocomplemodifyn}
                      >
                        <label>Traveller & Class</label>
                        <div
                          className={`${this.props.styles.flightautocompletetraveller} ${this.props.styles.passenger}`}
                        >
                          <span>
                            <svg
                              width="25px"
                              height="25px"
                              viewBox="0 0 200 200"
                            >
                              <g id="User__x2F__User_x5F_Circle">
                                <g id="Vector">
                                  <path
                                    fill="#30C8CA"
                                    d="M102,190.5c-18.541,0-35.737-5.862-49.833-15.833c-0.208-0.117-0.407-0.258-0.592-0.423
			C29.741,158.526,15.5,132.896,15.5,104c0-47.696,38.803-86.5,86.5-86.5c47.696,0,86.5,38.804,86.5,86.5
			c0,28.901-14.247,54.538-36.089,70.254c-0.178,0.158-0.368,0.292-0.566,0.405C137.747,184.632,120.544,190.5,102,190.5z
			 M58.958,171.183C71.384,179.171,86.161,183.81,102,183.81s30.613-4.638,43.04-12.626c-11.435-11.255-26.912-17.642-43.04-17.642
			C85.871,153.542,70.394,159.928,58.958,171.183z M102,146.852c18.293,0,35.831,7.407,48.59,20.422
			c18.972-14.604,31.22-37.537,31.22-63.273c0-44.007-35.803-79.81-79.81-79.81S22.19,59.993,22.19,104
			c0,25.736,12.247,48.668,31.218,63.272C66.168,154.258,83.707,146.852,102,146.852z M102,125.824
			c-17.129,0-31.063-13.936-31.063-31.063c0-17.128,13.935-31.063,31.063-31.063s31.063,13.935,31.063,31.063
			C133.063,111.889,119.129,125.824,102,125.824z M102,70.388c-13.439,0-24.373,10.934-24.373,24.373
			c0,13.438,10.934,24.372,24.373,24.372c13.439,0,24.373-10.934,24.373-24.372C126.373,81.322,115.439,70.388,102,70.388z"
                                  />
                                </g>
                              </g>
                            </svg>
                          </span>

                          <input
                            type={"text"}
                            value={
                              this.state.travellersObjOrigin.adults +
                              this.state.travellersObjOrigin.child +
                              this.state.travellersObjOrigin.infants
                            }
                            readOnly
                            /* tabIndex="2" */ onClick={
                              this.onTravellersClickHandler
                            } /* onFocusCapture={this.onTravellersClickHandler} */
                          />
                          <label onClick={this.onTravellersClickHandler}>
                            Passenger : {this.state.SelectedClassValue.label}{" "}
                          </label>
                          {/* <svg className={this.props.styles.dropArrow_mod} width="15px" height="24px" viewBox="0 0 200 200" stroke='#01445f'><polygon points="180.8,40.25 19.2,40.25 100.202,166.5 "></polygon></svg> */}
                          <svg
                            className={this.props.styles.dropArrow_mod}
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="9"
                          >
                            <path
                              fill-rule="evenodd"
                              fill="#01445F"
                              d="M11.59 1.135c.55-.413 1.102-.404 1.515.021.412.425.403 1.104.735 1.517L7.729 7.875l-.747-.769.748.772a1.072 1.072 0 0 1-1.519-.023l-.035-.038-5.25-5.144a1.074 1.074 0 0 1-.021-1.517 1.07 1.07 0 0 1 1.515-.021l4.565 4.473 4.605-4.473z"
                            ></path>
                          </svg>

                          {this.state.isTravelersPopupVisible && (
                            <EconomyPopup
                              travellerDivRef={this.travellerDivRef}
                              economyPopUpWrapper={this.economyPopUpWrapper}
                              state={this.state}
                              styles={this.props.styles}
                              cabinClass={cabinClass}
                              cabinClassSelectHandler={
                                this.cabinClassSelectHandler
                              }
                              onClickChangePaxNumber={
                                this.onClickChangePaxNumber
                              }
                              onClickOpenCabinClassList={
                                this.onClickOpenCabinClassList
                              }
                              onDoneBtnClickHandler={this.onDoneBtnClickHandler}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      className={this.props.styles.flightautocomplemodifybutton}
                      // id="search_button"
                    >
                      <button
                        tabIndex="2"
                        onClick={this.onClickSearchFlight}
                        onKeyDown={this.modifySearchKeyDownHandler}
                      >
                        Search
                        {/* <svg width="40px" height="40px" viewBox="0 0 200 200">
                        <g>
                            <path fill="#00A4F3" d="M109.039,50.665C66.53,11.72,8.749,69.501,47.694,112.01c8.4,8.4,19.6,12.728,30.545,12.728   C116.421,124.737,136.275,77.646,109.039,50.665z M105.221,108.192c-14.254,14.763-39.708,14.763-53.963,0   C27.331,84.52,44.64,42.774,78.239,43.029C111.839,42.774,129.148,84.52,105.221,108.192z"></path>
                            <path fill="#00A4F3" d="M169.875,155.537l-34.363-34.363c-3.055-3.055-7.382-3.563-10.437-1.527l-6.108-6.109   c38.69-52.436-29.782-113.526-77.382-68.981c-20.363,20.363-20.363,53.2,0,73.308c18.582,18.582,48.363,20.109,68.727,4.073   l6.364,6.363c-1.782,2.8-1.273,7.127,1.781,10.182l34.363,34.363c1.782,1.782,4.328,2.801,6.364,2.801   c1.781,0,3.563-0.51,4.836-1.782l6.873-6.873C173.693,163.938,173.185,158.846,169.875,155.537z M45.149,114.301   c-29.527-29.272-7.891-80.181,33.09-79.926c11.964,0,23.927,4.582,33.091,13.745C153.584,93.938,90.967,156.556,45.149,114.301z    M114.894,117.864c0.255-0.254,0.509-0.509,0.764-0.764l5.854,5.854l-1.527,1.527l-5.854-5.854   C114.385,118.374,114.639,118.119,114.894,117.864z M167.33,163.174l-6.873,6.872c-0.764,0.764-2.546,0.509-4.072-1.018   l-34.364-34.364c-1.781-2.036-1.526-3.563-0.254-4.836l5.091-5.091l1.018-1.019c1.273-1.018,2.801-0.254,4.073,1.019l34.363,34.363   C167.839,160.628,168.094,162.41,167.33,163.174z"></path>
                        </g>
                    </svg> */}
                      </button>
                    </div>
                    {/* <span class={this.props.styles.dropdown_arrowModify}>
                        <svg version="1.1" id="Layer_1" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 30 30" enable-background="new 0 0 30 30"><path id="Path_1101" data-name="Path 1101" d="M339.293,85.293l1.414,1.414L334,93.414l-6.707-6.707,1.414-1.414L334,90.586Z" transform="translate(-327.293 -85.293)" fill-rule="evenodd"></path></svg>
                    </span> */}
                  </div>
                )}
              </>
            ) : (
              <>
                {!this.state.openAirlines && (
                  <div
                    className={this.props.styles.flightsearchpage_widget_flex}
                  >
                    <div className={this.props.styles.flightmaindrops}>
                      <div className={this.props.styles.flightmaintops}>
                        <div
                          className={
                            this.props.styles.flightautocomplete_main_new
                          }
                        >
                          <FlightAutoComplete
                            label="From"
                            // id="flight_search_from"
                            value={this.state.departureValue}
                            state={this.state}
                            styles={this.props.styles}
                            onclickFlightAutoComplete={() =>
                              this.onclickFlightAutoComplete("departure")
                            }
                            leftIcon={
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="17"
                              >
                                <path
                                  fill-rule="evenodd"
                                  fill="#01445F"
                                  d="M23.819 6.123 8.442 12.885a1.015 1.015 0 0 1-.331.07.93.93 0 0 1-.474-.152L.924 8.43c-.126-.475-.225-.595-.285-.736-.179-.415.013-.897 1.031-1.076l1.294-.819a.82.82 0 0 1 .682 0L8.414 8.96l4.689-2.67-6.46-3.581a.817.817 0 0 1-.376-.398c.583-.413.004-.897.417-1.08l2.253-.99a.79.79 0 0 1 .589-.029L19.64 3.401l2.327-1.282a2.296 2.296 0 0 1 1.807 0c1.75.676 1.754 3.292.045 4.004zm-.695-2.505a.67.67 0 0 0-.52 0L19.456 5.5c-.191.42.024-.393-.609-.04L9.305 1.857l-.389.443 6.456 3.053a.82.82 0 0 1 .221 1.294.996.996 0 0 1-.266.184L8.72 9.746a.866.866 0 0 1-.266.061c-.14.011-.281-.014.006-.074L3.278 7.441l.052.098 4.875 3.66 14.919-6.587a.54.54 0 0 0 .265-.266c.128.374.009-.601-.265-.728zM1.398 15.35h22.895a.818.818 0 0 1 0 1.637H1.398a.819.819 0 0 1 0-1.637z"
                                ></path>
                              </svg>
                            }
                            placholder="Where are you going?"
                            onClickSourceAndDestination={(
                              city,
                              airPortCode,
                              airPortName
                            ) =>
                              this.onClickSetDepartureGoingToValue(
                                city,
                                airPortCode,
                                airPortName,
                                "departure"
                              )
                            }
                            onChangeSourceAndDestination={(value) =>
                              this.onChangeSetDepartureGoingToValue(
                                value,
                                "departure"
                              )
                            }
                            isAutoCompleteExpand={(bool) =>
                              this.setState({ expandDepartureBoolean: bool })
                            }
                            autoCompleteData={
                              !commonFunction.isValueEmpty(
                                this.props.getDepartureSuggestionList
                              )
                                ? this.props.getDepartureSuggestionList
                                : []
                            }
                            expandAutoCompleteBool={
                              !commonFunction.isValueEmpty(
                                this.state.expandDepartureBoolean
                              )
                                ? this.state.expandDepartureBoolean
                                : false
                            }
                            errorMessage={"Enter Origin City "}
                            isError={this.state.isError.departure}
                            listWrapper={this.departureListWrapper}
                            onKeyDownArrow={(event) => {
                              this.onKeyDownArrow(
                                event,
                                "flightDataArray",
                                this.props.getDepartureSuggestionList,
                                "departure"
                              );
                            }}
                            isModifySearch={true}
                          />
                        </div>

                        <span
                          className={this.props.styles.flight_swap}
                          tabIndex="2"
                          onKeyDown={this.onSwapKeyDownHandler}
                          onClick={() => {
                            this.onClickSwap();
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32"
                            height="32"
                            version="1.1"
                            id="Layer_1"
                            x="0px"
                            y="0px"
                            viewBox="0 0 33 33"
                          >
                            <g>
                              <path
                                class="st0"
                                d="M16.5,32.2c-8.7,0-15.7-7-15.7-15.7s7-15.7,15.7-15.7s15.7,7,15.7,15.7S25.1,32.2,16.5,32.2z M16.5,1.8   C8.4,1.8,1.8,8.4,1.8,16.5c0,8.1,6.6,14.7,14.7,14.7c8.1,0,14.7-6.6,14.7-14.7C31.2,8.4,24.6,1.8,16.5,1.8z"
                              ></path>
                            </g>
                            <polygon
                              class="st1"
                              points="25.6,22.3 25.6,22.3 25.6,22.3 "
                            ></polygon>
                            <g>
                              <path
                                class="st0"
                                d="M26.9,15.9c0.3-0.3,0.4-1.2,0-1.5l-5.5-5.5c-0.3-0.3-0.9-0.3-1.2,0C20.1,9,20,9.2,20,9.4   c0,0.2,0.1,0.4,0.2,0.6l4.2,4.2l-17.8,0c-0.5,0-0.8,0.4-0.8,0.8l0,0c0,0.5,0.4,0.8,0.8,0.8h17.6"
                              ></path>
                              <path
                                class="st0"
                                d="M6.1,17.1c-0.3,0.3-0.4,1.2,0,1.5l5.5,5.5c0.3,0.3,0.9,0.3,1.2,0c0.2-0.2,0.2-0.4,0.2-0.6   c0-0.2-0.1-0.4-0.2-0.6l-4.2-4.2l17.8,0c0.5,0,0.8-0.4,0.8-0.8l0,0c0-0.5-0.4-0.8-0.8-0.8H8.8"
                              ></path>
                            </g>
                          </svg>
                        </span>

                        <div
                          className={this.props.styles.flightautocomplete_main}
                        >
                          <FlightAutoComplete
                            label="To"
                            // id="flight_search_to"
                            value={this.state.goingToValue}
                            styles={this.props.styles}
                            state={this.state}
                            onclickFlightAutoComplete={() =>
                              this.onclickFlightAutoComplete("goingTo")
                            }
                            leftIcon={
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="26"
                                height="19"
                              >
                                <path
                                  fill-rule="evenodd"
                                  fill="#01445F"
                                  d="M24.293 18.987H1.398a.819.819 0 0 1 0-1.637h22.895a.818.818 0 0 1 0 1.637zm-2.001-4.807L5.715 11.466a1.031 1.031 0 0 1-.316-.122c-.137-.098-.246-.231.441-.386L2.52 3.307c-.526-.141-.543-.197-.22-.447.5-.446.203-.745.649-.669l2.036.348a.823.823 0 0 1 .573.372l2.744 4.524 5.058.824-3.605-6.305a.819.819 0 0 1 .84-1.216l2.635.397c-.005.03.177.137.302.297l6.258 7.874 3.132.508c.619.107 1.958.463 1.515.985 1.099 1.521-.324 3.716-2.145 3.381zm1.458-2.479c-.776-.149-.933-.251-1.11-.283l-3.396-.553c.116-.032-.397-.137-.533-.298L12.45 2.692l-.14-.068 3.321 6.306c.039.068.068.79.086.219.105.439-.167 1.151-.607.986.29.021-.215.024-.323.009L7.66 8.986a.872.872 0 0 1-.257-.094.815.815 0 0 1-.302-.284L4.354 4.87l.596-.52 1.485 5.573 16.098 2.612a.553.553 0 0 0 .368-.078c.256-.161.335-.499.849-.756z"
                                ></path>
                              </svg>
                            }
                            placholder="Where are you going?"
                            onClickSourceAndDestination={(
                              city,
                              airPortCode,
                              airPortName
                            ) =>
                              this.onClickSetDepartureGoingToValue(
                                city,
                                airPortCode,
                                airPortName,
                                "goingTo"
                              )
                            }
                            onChangeSourceAndDestination={(value) =>
                              this.onChangeSetDepartureGoingToValue(
                                value,
                                "goingTo"
                              )
                            }
                            isAutoCompleteExpand={(bool) =>
                              this.setState({ expandGoingToBoolean: bool })
                            }
                            autoCompleteData={
                              !commonFunction.isValueEmpty(
                                this.props.getGoingToSuggestionList
                              )
                                ? this.props.getGoingToSuggestionList
                                : []
                            }
                            expandAutoCompleteBool={
                              this.state.expandGoingToBoolean
                            }
                            errorMessage={
                              this.state.departureValue.length &&
                              this.state.goingToValue.length &&
                              this.state.departureValue ===
                                this.state.goingToValue
                                ? "Origin and destination cannot be same"
                                : "Enter Destination City"
                            }
                            isError={this.state.isError.goingTo}
                            listWrapper={this.returnListWrapper}
                            onKeyDownArrow={(event) => {
                              this.onKeyDownArrow(
                                event,
                                "flightDataArray",
                                this.props.getGoingToSuggestionList,
                                "goingTo"
                              );
                            }}
                            isModifySearch={true}
                          />
                        </div>
                        <div
                          className={
                            this.props.styles.flightautocompletecalender
                          }
                        >
                          <DesktopCalender
                            label="Departure"
                            // id="flight_departure"
                            styles={this.props.styles}
                            value={
                              !commonFunction.isValueEmpty(
                                this.state.departureDate
                              )
                                ? this.state.departureDate
                                : ""
                            }
                            placholder="Departure Date"
                            onChangeDate={(value) => {
                              this.onChangeDepartureGoingDateValue(
                                value,
                                "goindeparturegTo"
                              );
                            }}
                            iconImage={
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="19"
                              >
                                <path
                                  fill-rule="evenodd"
                                  fill="#01445F"
                                  d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.84V3.149c0 .161-.48-.225-.882-.304a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.59.627.967v13.507c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627C.153 17.374 0 17.32 0 16.655V3.149c0-.377.153-.719.401-.967.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.304v3.498zm16.922.94H.938v9.068c0 .117.049.224.702.304-.498.401-.391.891-.272.891h15.288c.118 0 .225-.49.304-.891.42-.078.9-.185.9-.304V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"
                                ></path>
                              </svg>
                            }
                            startDate={
                              !commonFunction.isValueEmpty(
                                this.state.departureDate
                              )
                                ? this.state.departureDate
                                : ""
                            }
                            endDate={
                              !commonFunction.isValueEmpty(
                                this.state.returnDate
                              )
                                ? this.state.returnDate
                                : ""
                            }
                            startDateLimit={
                              !commonFunction.isValueEmpty(todaysDate)
                                ? todaysDate
                                : ""
                            }
                            dateFormat={this.props.dateFormat}
                            changeVisibility={(bool) =>
                              this.onchangeVisibility(bool, "departure")
                            }
                            isVisible={this.state.expandDepartureDateBoolean}
                            type={"double"}
                            doubleSelection={false}
                          />
                        </div>
                        <div
                          className={
                            this.props.styles.flightautocompletecalender
                          }
                        >
                          <div className={this.props.styles.return_calendar}>
                            <DesktopCalender
                              label="Return"
                              // id="flight_return"
                              styles={this.props.styles}
                              value={
                                this.state.isOnewaySearch === false
                                  ? !commonFunction.isValueEmpty(
                                      this.state.returnDate
                                    )
                                    ? this.state.returnDate
                                    : ""
                                  : ""
                              }
                              placholder=""
                              onChangeDate={(value) => {
                                this.onChangeDepartureGoingDateValue(
                                  value,
                                  "goingTo"
                                );
                              }}
                              iconImage={
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="19"
                                  height="19"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    fill="#01445F"
                                    d="M11.971.693c0-.383.378-.693.846-.693.468 0 .847.31.847.693v3.039c0 .383-.379.694-.847.694-.468 0-.846-.311-.846-.694V.693zM9.697 15.226c-.05 0-.089-.056-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .413.527.469.027.469H9.697zM2.324 9.84c-.049 0-.089-.21-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .259-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.21-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .259-.04.469-.09.469H6.11zm3.587 0c-.05 0-.089-.21-.089-.469 0-.26.039-.47.089-.47h2.433c.5 0-.027.21-.027.47 0 .259.527.469.027.469H9.697zm3.688 0c-.05 0-.09-.21-.09-.469 0-.26.04-.47.09-.47h2.316c.05 0 .09.21.09.47 0 .259-.04.469-.09.469h-2.316zM2.324 12.533c-.049 0-.089-.209-.089.107 0-.836.04-1.046.089-1.046h2.317c.05 0 .089.21.089 1.046 0-.316-.039-.107-.089-.107H2.324zm3.786 0c-.149 0-.189-.209-.189.107 0-.836.04-1.046.189-1.046h2.217c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107H6.11zm3.587 0c-.05 0-.089-.209-.089.107 0-.836.039-1.046.089-1.046h2.433c.5 0-.027.21-.027 1.046 0-.316.527-.107.027-.107H9.697zm3.688 0c-.05 0-.09-.209-.09.107 0-.836.04-1.046.09-1.046h2.316c.05 0 .09.21.09 1.046 0-.316-.04-.107-.09-.107h-2.316zM2.324 15.226c-.049 0-.089-.056-.089-.469 0-.26.04-.47.089-.47h2.317c.05 0 .089.21.089.47 0 .413-.039.469-.089.469H2.324zm3.786 0c-.149 0-.189-.056-.189-.469 0-.26.04-.47.189-.47h2.217c.05 0 .09.21.09.47 0 .413-.04.469-.09.469H6.11zM4.343.693c0-.383.378-.693.846-.693.468 0 1.171.31 1.171.693v3.039c0 .383-.703.694-1.171.694-.468 0-.846-.311-.846-.694V.693zM.938 6.647H17.84V3.149c0 .161-.48-.225-.882-.304a.424.424 0 0 0-.303-.126h-1.546a.47.47 0 1 1 0-.939h1.547c.674 0 .719.154.967.402.248.248.627.59.627.967v13.507c0 .674-.379.719-.627.967s-.293.627-.967.627H1.368c-.377 0-.719-.379-.967-.627C.153 17.374 0 17.32 0 16.655V3.149c0-.377.153-.719.401-.967.248-.248.59-.402.967-.402H3.21c.071 0 .281.21.281.469 0 .26-.21.47-.281.47H1.368c-.117 0-.224.048.272.126-.653.078-.702.455-.702.304v3.498zm16.922.94H.938v9.068c0 .117.049.224.702.304-.498.401-.391.891-.272.891h15.288c.118 0 .225-.49.304-.891.42-.078.9-.185.9-.304V7.587zM7.397 2.719a.469.469 0 1 1 0-.939h3.152c.26 0 .641.21.641.469 0 .26-.381.47-.641.47H7.397z"
                                  ></path>
                                </svg>
                              }
                              startDate={
                                !commonFunction.isValueEmpty(
                                  this.state.departureDate
                                )
                                  ? this.state.departureDate
                                  : ""
                              }
                              endDate={
                                !commonFunction.isValueEmpty(
                                  this.state.returnDate
                                )
                                  ? this.state.returnDate
                                  : ""
                              }
                              startDateLimit={
                                !commonFunction.isValueEmpty(
                                  this.state.departureDate
                                )
                                  ? this.state.departureDate
                                  : ""
                              }
                              dateFormat={this.props.dateFormat}
                              changeVisibility={(bool) =>
                                this.onchangeVisibility(bool, "goingTo")
                              }
                              isVisible={this.state.expandReturnDateBoolean}
                              type={"double"}
                              doubleSelection={false}
                            />
                          </div>
                        </div>

                        <div
                          className={this.props.styles.flightautocomplemodify}
                        >
                          <label>Traveler & Class</label>
                          <div
                            className={`${this.props.styles.flightautocompletetraveller} ${this.props.styles.passenger}`}
                          >
                            <span>
                              <svg
                                width="20px"
                                height="20px"
                                viewBox="0 0 200 200"
                              >
                                <g>
                                  <path
                                    fill="#01445f"
                                    d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"
                                  ></path>
                                </g>
                              </svg>
                            </span>

                            <input
                              type={"text"}
                              value={
                                this.state.travellersObjOrigin.adults +
                                this.state.travellersObjOrigin.child +
                                this.state.travellersObjOrigin.infants
                              }
                              readOnly
                              /* tabIndex="2" */ onClick={
                                this.onTravellersClickHandler
                              } /* onFocusCapture={this.onTravellersClickHandler} */
                            />
                            <label onClick={this.onTravellersClickHandler}>
                              Passenger : {this.state.SelectedClassValue.label}
                            </label>
                            {/* <svg className={this.props.styles.dropArrow_mod} width="15px" height="24px" viewBox="0 0 200 200"><polygon points="180.8,40.25 19.2,40.25 100.202,166.5 "></polygon></svg> */}
                            <svg
                              className={this.props.styles.dropArrow_mod}
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="9"
                            >
                              <path
                                fill-rule="evenodd"
                                fill="#01445F"
                                d="M11.59 1.135c.55-.413 1.102-.404 1.515.021.412.425.403 1.104.735 1.517L7.729 7.875l-.747-.769.748.772a1.072 1.072 0 0 1-1.519-.023l-.035-.038-5.25-5.144a1.074 1.074 0 0 1-.021-1.517 1.07 1.07 0 0 1 1.515-.021l4.565 4.473 4.605-4.473z"
                              ></path>
                            </svg>

                            {this.state.isTravelersPopupVisible && (
                              <EconomyPopup
                                travellerDivRef={this.travellerDivRef}
                                economyPopUpWrapper={this.economyPopUpWrapper}
                                state={this.state}
                                styles={this.props.styles}
                                cabinClass={cabinClass}
                                cabinClassSelectHandler={
                                  this.cabinClassSelectHandler
                                }
                                onClickChangePaxNumber={
                                  this.onClickChangePaxNumber
                                }
                                onClickOpenCabinClassList={
                                  this.onClickOpenCabinClassList
                                }
                                onDoneBtnClickHandler={
                                  this.onDoneBtnClickHandler
                                }
                              />
                            )}
                          </div>
                        </div>
                        <div
                          className={
                            this.props.styles.flightautocomplemodifybutton
                          }
                        >
                          <button
                            tabIndex="2"
                            onClick={this.onClickSearchFlight}
                            onKeyDown={this.modifySearchKeyDownHandler}
                          >
                            {/* <svg width="40px" height="40px" viewBox="0 0 200 200">
                <g>
                    <path fill="#00A4F3" d="M109.039,50.665C66.53,11.72,8.749,69.501,47.694,112.01c8.4,8.4,19.6,12.728,30.545,12.728   C116.421,124.737,136.275,77.646,109.039,50.665z M105.221,108.192c-14.254,14.763-39.708,14.763-53.963,0   C27.331,84.52,44.64,42.774,78.239,43.029C111.839,42.774,129.148,84.52,105.221,108.192z"></path>
                    <path fill="#00A4F3" d="M169.875,155.537l-34.363-34.363c-3.055-3.055-7.382-3.563-10.437-1.527l-6.108-6.109   c38.69-52.436-29.782-113.526-77.382-68.981c-20.363,20.363-20.363,53.2,0,73.308c18.582,18.582,48.363,20.109,68.727,4.073   l6.364,6.363c-1.782,2.8-1.273,7.127,1.781,10.182l34.363,34.363c1.782,1.782,4.328,2.801,6.364,2.801   c1.781,0,3.563-0.51,4.836-1.782l6.873-6.873C173.693,163.938,173.185,158.846,169.875,155.537z M45.149,114.301   c-29.527-29.272-7.891-80.181,33.09-79.926c11.964,0,23.927,4.582,33.091,13.745C153.584,93.938,90.967,156.556,45.149,114.301z    M114.894,117.864c0.255-0.254,0.509-0.509,0.764-0.764l5.854,5.854l-1.527,1.527l-5.854-5.854   C114.385,118.374,114.639,118.119,114.894,117.864z M167.33,163.174l-6.873,6.872c-0.764,0.764-2.546,0.509-4.072-1.018   l-34.364-34.364c-1.781-2.036-1.526-3.563-0.254-4.836l5.091-5.091l1.018-1.019c1.273-1.018,2.801-0.254,4.073,1.019l34.363,34.363   C167.839,160.628,168.094,162.41,167.33,163.174z"></path>
                </g>
            </svg> */}
                            Search
                          </button>
                        </div>
                      </div>
                      {/* <div className={this.props.styles.flightmainbots}>
              <div className={this.props.styles.flightfare}>
                <label>Select Fare Type</label>
                <div className={this.props.styles.flightmainfare}>
                  <span>
                  <svg width="20px" height="20px" viewBox="0 0 200 200"><g><path fill="#01445f" d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"></path></g></svg>
                  </span>
                  <label>Select Fare Type</label>
                  <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9"><path fill-rule="evenodd" fill="#01445f" d="M11.59 1.135c.55-.413 1.102-.404 1.515.021.412.425.403 1.104.735 1.517L7.729 7.875l-.747-.769.748.772a1.072 1.072 0 0 1-1.519-.023l-.035-.038-5.25-5.144a1.074 1.074 0 0 1-.021-1.517 1.07 1.07 0 0 1 1.515-.021l4.565 4.473 4.605-4.473z"></path></svg>
                  </span>
                </div>
              </div>
            </div> */}
                    </div>
                  </div>
                )}
              </>
            )}
            {this.state.openAirlines &&
              this.state.isOnewaySearch &&
              !this.state.isMultiCitySearch && (
                <>
                  <ModifyAdvanceSearchOneWay
                    theme="theme4"
                    styles={this.props.b2bStyles}
                    styles1={this.props.styles}
                    state={this.state}
                    setState={this.setState}
                    cabinClass={cabinClass}
                    onClickTraveller={this.onClickTraveller}
                    passengerDropdownWrapper={this.passengerDropdownWrapper}
                    departureListWrapper={this.departureListWrapper}
                    returnListWrapper={this.returnListWrapper}
                    onClickAirlines={this.onClickAirlines}
                    removeGuestId={this.rmGuestId}
                    onChangeClassValue={this.onChangeAdvOneWayClassValue}
                    handleOnChangeAirlines={this.handleOnChangeAirlines}
                    applyb2bFilters={this.applyb2bFilters}
                    addGuestId={this.adGuestId}
                    listWrapper={this.advanceSearchWrapper}
                    guestWrapper={this.guestDetailWrapper}
                    onchangeVisibility={this.onchangeVisibility}
                    onChangeDepartureGoingDateValue={
                      this.onChangeDepartureGoingDateValue
                    }
                    onClickSetDepartureGoingToValue={
                      this.onClickSetDepartureGoingToValue
                    }
                    onclickFlightAutoComplete={this.onclickFlightAutoComplete}
                    onClickOpenCabinClassList={this.onClickOpenCabinClassList}
                    onClickOpenPassangerList={this.onClickOpenPassangerList}
                    onClickChangePaxNumber={this.onClickChangePaxNumber}
                    onSwapKeyDownHandler={this.onSwapKeyDownHandler}
                    onClickSwap={this.onClickSwap}
                    onChangeSetDepartureGoingToValue={
                      this.onChangeSetDepartureGoingToValue
                    }
                    getDepartureSuggestionList={
                      this.props.getDepartureSuggestionList
                    }
                    getGoingToSuggestionList={
                      this.props.getGoingToSuggestionList
                    }
                    onKeyDownArrow={this.onKeyDownArrow}
                    onClickSearchFlight={this.onClickSearchFlight}
                    multiSelectDropdown={this.props?.multiSelectDropdown()}
                    multiSelectSupplierDropdown={this.props.multiSelectSupplierDropdown()}
                    multiSelectDepartureTimeDropdown={this.props.multiSelectDepartureTimeDropdown()}
                    multiSelectRBDClassDropdown={this.props.multiSelectRBDClassDropdown()}
                    handleStopCheck={this.handleStopCheck}
                    isOffline={this.props.isOffline}
                    errorMessage={"Select Traveler"}
                    isError={this.state.isError.selectedGuest}
                    economyPopUpWrapper={this.economyPopUpWrapper}
                    onRBDClick={this.onRBDClick}
                  />
                </>
              )}
            {this.state.openAirlines &&
              !this.state.isOnewaySearch &&
              !this.state.isMultiCitySearch && (
                <ModifyAdvanceSearchRoundTrip
                  theme="theme4"
                  styles={this.props.b2bStyles}
                  styles1={this.props.styles}
                  state={this.state}
                  setState={this.setState}
                  cabinClass={cabinClass}
                  onClickTraveller={this.onClickTraveller}
                  passengerDropdownWrapper={this.passengerDropdownWrapper}
                  departureListWrapper={this.departureListWrapper}
                  returnListWrapper={this.returnListWrapper}
                  onClickAirlines={this.onClickAirlines}
                  removeGuestId={this.rmGuestId}
                  onChangeClassValue={this.onChangeClassValue}
                  onChangeAdvRoundClassValueOne={
                    this.onChangeAdvRoundClassValueOne
                  }
                  onChangeAdvRoundClassValueTwo={
                    this.onChangeAdvRoundClassValueTwo
                  }
                  handleOnChangeAirlines={this.handleOnChangeAirlines}
                  applyb2bFilters={this.applyb2bFilters}
                  addGuestId={this.adGuestId}
                  listWrapper={this.advanceSearchWrapper}
                  guestWrapper={this.guestDetailWrapper}
                  cabinPopUpWrapperOne={this.cabinPopUpWrapperOne}
                  cabinPopUpWrapperTwo={this.cabinPopUpWrapperTwo}
                  onchangeVisibility={this.onchangeVisibility}
                  onChangeDepartureGoingDateValue={
                    this.onChangeDepartureGoingDateValue
                  }
                  onClickSetDepartureGoingToValue={
                    this.onClickSetDepartureGoingToValue
                  }
                  onclickFlightAutoComplete={this.onclickFlightAutoComplete}
                  onClickOpenCabinClassListOne={
                    this.onClickOpenCabinClassListOne
                  }
                  onClickOpenCabinClassListTwo={
                    this.onClickOpenCabinClassListTwo
                  }
                  onClickOpenPassangerList={this.onClickOpenPassangerList}
                  onClickChangePaxNumber={this.onClickChangePaxNumber}
                  onSwapKeyDownHandler={this.onSwapKeyDownHandler}
                  onClickSwap={this.onClickSwap}
                  onChangeSetDepartureGoingToValue={
                    this.onChangeSetDepartureGoingToValue
                  }
                  getDepartureSuggestionList={
                    this.props.getDepartureSuggestionList
                  }
                  getGoingToSuggestionList={this.props.getGoingToSuggestionList}
                  onKeyDownArrow={this.onKeyDownArrow}
                  multiSelectDropdown={this.props?.multiSelectDropdown()}
                  multiSelectSupplierDropdown={this.props.multiSelectSupplierDropdown()}
                  multiSelectDepartureTimeDropdown={
                    this.props.isOffline === false
                      ? this.props.multiSelectDepartureTimeDropdown()
                      : ""
                  }
                  multiSelectRBDClassDropdown={this.props.multiSelectRBDClassDropdown()}
                  handleStopCheck={this.handleStopCheck}
                  isOffline={this.props.isOffline}
                  errorMessage={"Select Traveler"}
                  isError={this.state.isError.selectedGuest}
                  onClickSearchFlight={this.onClickSearchFlight}
                  updateMulticityDepartureTime={this.props.multiSelectDepartureTimeDropdown()}
                  economyPopUpWrapper={this.economyPopUpWrapper}
                  expandGoingToDateBoolean={this.state.expandGoingToDateBoolean}
                  onRBDClickOne={this.onRBDClickOne}
                  onRBDClickTwo={this.onRBDClickTwo}
                />
              )}

            {this.state.openAirlines &&
              !this.state.isOnewaySearch &&
              this.state.isMultiCitySearch && (
                <ModifyAdvanceSearchMulticity
                  theme="theme4"
                  styles={this.props.b2bStyles}
                  styles1={this.props.styles}
                  state={this.state}
                  setState={this.setState}
                  cabinClass={cabinClass}
                  onClickTraveller={this.onClickTraveller}
                  passengerDropdownWrapper={this.passengerDropdownWrapper}
                  departureListWrapper={this.departureListWrapper}
                  returnListWrapper={this.returnListWrapper}
                  economyPopUpWrapper={this.economyPopUpWrapper}
                  onClickAirlines={this.onClickAirlines}
                  AddFlightButton={this.AddFlightButton}
                  removeGuestId={this.rmGuestId}
                  onChangeClassValue={this.onChangeClassValue}
                  handleOnChangeAirlines={this.handleOnChangeAirlines}
                  applyb2bFilters={this.applyb2bFilters}
                  addGuestId={this.adGuestId}
                  listWrapper={this.advanceSearchWrapper}
                  guestWrapper={this.guestDetailWrapper}
                  onchangeVisibility={this.onchangeVisibility}
                  RemoveFlightObject={this.RemoveFlightObject}
                  onChangeDepartureGoingDateValue={
                    this.onChangeDepartureGoingDateValue
                  }
                  onClickSetDepartureGoingToValue={
                    this.onClickSetDepartureGoingToValue
                  }
                  onclickFlightAutoComplete={this.onclickFlightAutoComplete}
                  onClickOpenCabinClassListMulticity={
                    this.onClickOpenCabinClassListMulticity
                  }
                  onClickOpenPassangerList={this.onClickOpenPassangerList}
                  onClickChangePaxNumber={this.onClickChangePaxNumber}
                  onSwapKeyDownHandler={this.onSwapKeyDownHandler}
                  onClickSwap={this.onClickSwap}
                  onChangeSetDepartureGoingToValue={
                    this.onChangeSetDepartureGoingToValue
                  }
                  getDepartureSuggestionList={
                    this.props.getDepartureSuggestionList
                  }
                  getGoingToSuggestionList={this.props.getGoingToSuggestionList}
                  onKeyDownArrow={this.onKeyDownArrow}
                  multiSelectAdvanceRBDClassDropdown={
                    this.multiSelectAdvanceRBDClassDropdown
                  }
                  multiSelectAdvanceAirlineClassDropdown={
                    this.multiSelectAdvanceAirlineClassDropdown
                  }
                  updateMulticityDepartureTime={
                    this.updateMulticityDepartureTime
                  }
                  multicityReturnWrapper={this.multicityReturnWrapper}
                  multicityDepartureWrapper={this.multicityDepartureWrapper}
                  multiSelectDropdown={
                    this.props.isOffline === false
                      ? this.props?.multiSelectDropdown()
                      : ""
                  }
                  multiSelectSupplierDropdown={this.props.multiSelectSupplierDropdown()}
                  multiSelectDepartureTimeDropdown={
                    this.props.isOffline === false
                      ? this.props.multiSelectDepartureTimeDropdown()
                      : ""
                  }
                  multiSelectRBDClassDropdown={
                    this.props.isOffline === false
                      ? this.props.multiSelectRBDClassDropdown()
                      : ""
                  }
                  handleStopCheck={this.handleStopCheck}
                  isOffline={this.props.isOffline}
                  errorMessage={"Select Traveler"}
                  isError={this.state.isError.selectedGuest}
                  onClickSearchFlight={this.onClickSearchFlight}
                  onRbDClickMulti={this.onRbDClickMulti}
                  dateFormat={this.props.dateFormat}
                />
              )}
            <div className={`${this.props.styles.adv_tabs_split}`}>
              {/* <div className={props.styles.icon_box_adv}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19">
                  <path fill-rule="evenodd" fill="#01445F" d="M7.668 18.778H1.577c-.42 0-.761-.341-.761-.608 0-.574.341-.915.761-.915h6.091c1.212 0 .761.341.761.915 0 .267.451.608-.761.608zm-1.523-3.047H1.577a.762.762 0 0 1 0-1.523h4.568a.76.76 0 1 1 0 1.523zm-1.523-3.047H1.577a.762.762 0 0 1 0-1.524h3.045c.808 0 .762.341.762.762s.046.762-.762.762zm6.091 6.06c-.42.019-.776-.307-.795-.584-.019-.564.307-.921.727-.939a7.618 7.618 0 0 0 6.888-8.281c-.383-4.19-4.088-7.276-8.275-6.47C5.6 2.382 2.703 5.283 2.37 8.943a.762.762 0 1 1-1.517-.137C1.309 3.778 5.751.71 10.776.527c4.709.427 9.124 4.378 9.104 9.11-.768 4.736-4.382 8.698-9.098 9.104a.814.814 0 0 1-.069.003zM9.952 5.66c-.421 0-.762-.253-.762.167v3.81c0 .202.081.683.223.538l2.284 2.286a.761.761 0 0 0 1.077-.019c.816-.295.816-.763 0-1.059l-2.061-2.062V5.827c0-.42-.341-.167-.761-.167z"/>
              </svg>
              </div> */}
              <div
                className={`${this.props.styles.departure_main_box} ${this.props.styles.fare_main_box}`}
              >
                <div className={this.props.styles.label_fname}>
                  <label htmlFor="fname" className="lablename-htl">
                    Select Fare Type
                  </label>
                </div>
                <div className={`${this.props.styles.icon_box_advInput}`}>
                  <div className={this.props.styles.icon_box_advFare}>
                    <svg width="15px" height="15px" viewBox="0 0 200 200">
                      <g>
                        <path
                          fill="#30C8CA"
                          d="M100,188.716c-48.918,0-88.716-39.798-88.716-88.716S51.082,11.284,100,11.284S188.716,51.082,188.716,100 S148.918,188.716,100,188.716z M45.883,162.507c14.516,12.586,33.442,20.209,54.117,20.209c20.675,0,39.602-7.624,54.118-20.209 c-1.134-27.888-38.089-30.935-54.118-30.935S47.016,134.62,45.883,162.507z M100,17.284c-45.61,0-82.716,37.106-82.716,82.716 c0,22.237,8.82,42.452,23.146,57.331c1.983-10.823,9.079-19.279,20.815-24.682c12.708-5.85,28.09-7.077,38.755-7.077 c10.666,0,26.048,1.228,38.756,7.077c11.736,5.402,18.832,13.858,20.814,24.682c14.326-14.88,23.146-35.094,23.146-57.331 C182.716,54.39,145.609,17.284,100,17.284z M100,103c-17.409,0-31.572-14.163-31.572-31.572c0-17.409,14.163-31.572,31.572-31.572 c17.409,0,31.572,14.163,31.572,31.572C131.572,88.837,117.409,103,100,103z M100,45.856c-14.1,0-25.572,11.472-25.572,25.572 C74.428,85.528,85.9,97,100,97c14.101,0,25.572-11.472,25.572-25.572C125.572,57.328,114.101,45.856,100,45.856z"
                        ></path>
                      </g>
                    </svg>
                  </div>
                  {this.props.selectFareTypeDropdown()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ModifySearch;
